import { DialogContent } from 'components/dialogs';
import { styled } from 'libs/ui/styled';

export const DialogContentStyled = styled(DialogContent)(() => ({
  width: 1144,
}));
